module.exports = require('./src/donut-chart');


// WEBPACK FOOTER //
// ./index.js